import { useState } from "react";
import { Icon, IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { IRelPaymentsPeriod } from "interfaces/reports";
import {
  getDetailBoleto,
  getDetailCartaoCredito,
  getDetailPix,
} from "services/payments";
import { IDetailsBoleto } from "interfaces/detailsBoleto";
import { IDetailsPix } from "interfaces/detailsPix";
import { IDetailsCartaoEfi } from "interfaces/detailsCartao";

type PaymentDetails = IDetailsBoleto | IDetailsPix | IDetailsCartaoEfi | null;

interface Props {
  payment: IRelPaymentsPeriod;
  detailsPayment: (payment: PaymentDetails) => void;
}

export default function MenuMore({ payment, detailsPayment }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [isLoading, setIsLoading] = useState(false);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const handleDetailsPayment = async () => {
    setIsLoading(true);
    //Verificar qual forma de pagamento
    if (payment.cobrancaBoleto) {
      if (payment.cobrancaBoleto.card_mask) {
        const changeId = payment.cobrancaBoleto.charge_id;
        const detailsCartao = await getDetailCartaoCredito(changeId).finally(
          () => setIsLoading(false)
        );
        detailsPayment(detailsCartao);
      } else {
        const changeId = payment.cobrancaBoleto.charge_id;
        const detailBoleto = await getDetailBoleto(changeId).finally(() =>
          setIsLoading(false)
        );
        detailsPayment(detailBoleto);
      }
    }

    if (payment.cobrancaPix) {
      const txid = payment.cobrancaPix.txid;
      const detailsPix = await getDetailPix(txid).finally(() =>
        setIsLoading(false)
      );
      detailsPayment(detailsPix);
    }
    handleClose();
  };

  return (
    <div>
      <IconButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Icon
          sx={{
            animation: isLoading ? "spin 1s linear infinite" : "",
            "@keyframes spin": {
              "0%": { transform: "rotate(0deg)" },
              "100%": { transform: "rotate(360deg)" },
            },
          }}
        >
          {isLoading ? "rotate_right" : "more_vert"}
        </Icon>
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleDetailsPayment}>
          <ListItemIcon>
            <Icon fontSize="medium">feed_outlined</Icon>
          </ListItemIcon>
          Detalhes do pagamento
        </MenuItem>
      </Menu>
    </div>
  );
}
